import { render, staticRenderFns } from "./merchantDetail.vue?vue&type=template&id=2b5513f4&scoped=true"
import script from "./merchantDetail.vue?vue&type=script&lang=js"
export * from "./merchantDetail.vue?vue&type=script&lang=js"
import style0 from "./merchantDetail.vue?vue&type=style&index=0&id=2b5513f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5513f4",
  null
  
)

export default component.exports